import { heroStats } from "@/mocks/siteData";

export default function Stats() {
  return (
    <section id="stats" className="scroll-mt-20 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <div className="reveal grid grid-cols-2 gap-4 md:grid-cols-4 md:gap-6">
          {heroStats.map((stat) => (
            <div
              key={stat.label}
              className="rounded-lg border border-background-200 bg-background-100/60 px-5 py-6 text-center"
            >
              <div className="font-heading text-2xl text-primary-600 md:text-4xl">{stat.value}</div>
              <div className="mt-2 text-xs text-foreground-600 md:text-sm">{stat.label}</div>
            </div>
          ))}
        </div>
        <p className="reveal mt-5 text-center text-xs text-foreground-500">
          以上为平台阶段性概览数据，实际数量随作品入库与更新持续变动。
        </p>
      </div>
    </section>
  );
}